import IntegrationError from './IntegrationError';

export default IntegrationError;
